import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Redirect, useLocation, useParams } from 'react-router'
import { Link } from 'react-router-dom'

import { selectCurrentHotelId, selectCurrentHotels } from '../../accessors/index'
import { postAndSelectSubsidiary, savePrevPath } from '../../actions/index'
import { saveSubsidiary } from '../../utils/helpers'

const SwitchToHotelAndGoToPath = () => {
  const dispatch = useDispatch()

  const { subsidiaryId } = useParams()
  let location = useLocation()

  const prevPath = useSelector(s => s.login.prevPath)

  const pathToGo = `${location.pathname}${location.search}`.match(
    /^\/s\/[a-zA-Z-0-9]+(\/.+)$/
  )[1]

  const currentSubsidiaryId = useSelector(selectCurrentHotelId)

  const currentSubsidiaryList = useSelector(selectCurrentHotels)

  const isLoggedIn = useSelector(s => s.login.userLoggedIn)

  const [hasNoAccess, setHasNoAccess] = useState(false)

  useEffect(() => {
    if (currentSubsidiaryId && isLoggedIn) {
      if (currentSubsidiaryId !== subsidiaryId) {
        const match = currentSubsidiaryList.find(s => s.subsidiaryId === subsidiaryId)

        if (match) {
          dispatch(savePrevPath(`${location.pathname}${location.search}`))
          saveSubsidiary({
            subsidiaryId
          })
          dispatch(postAndSelectSubsidiary(subsidiaryId))
        } else {
          setHasNoAccess(true)
        }
      }
    }
  }, [
    currentSubsidiaryId,
    currentSubsidiaryList,
    dispatch,
    isLoggedIn,
    location.pathname,
    location.search,
    subsidiaryId
  ])

  if (!isLoggedIn && prevPath !== location.pathname) {
    saveSubsidiary({ subsidiaryId })

    return <Redirect to="/login" />
  }

  if (!isLoggedIn) {
    dispatch(savePrevPath(`${location.pathname}${location.search}`))
    return <Redirect to="/login" />
  }

  if (!currentSubsidiaryId) {
    saveSubsidiary({ subsidiaryId })
    dispatch(savePrevPath(`${location.pathname}${location.search}`))

    return <Redirect to="/selectHotel" />
  }

  if (hasNoAccess) {
    return (
      <div>
        You don't have access to this. <Link to="/">Go back home</Link>.{' '}
      </div>
    )
  }

  if (currentSubsidiaryId === subsidiaryId) {
    // eslint-disable-next-line no-unused-vars
    const [_r, pathname, search = ''] = pathToGo.match(/([^?]+)(\?.*)?/)

    return <Redirect to={{ pathname, search }} />
  }

  return null
}

export default SwitchToHotelAndGoToPath
